import React from "react";

const STATUS_CONFIG = {
  PENDING: { label: "Pendiente", className: "bg-amber-100 text-amber-700 border-amber-200" },
  ACTIVE: { label: "Activo", className: "border", style: { backgroundColor: '#B2EBF2', color: '#008B9A', borderColor: '#80DEEA' } },
  SUSPENDED: { label: "Suspendido", className: "bg-gray-100 text-gray-600 border-gray-200" },
  REJECTED: { label: "Rechazado", className: "bg-red-100 text-red-700 border-red-200" },
};

const StatusBadge = ({ status }) => {
  const config = STATUS_CONFIG?.[status] || STATUS_CONFIG?.PENDING;
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-caption font-semibold border ${config?.className}`}
      style={config?.style || {}}
    >
      {config?.label}
    </span>
  );
};

export default StatusBadge;